import * as React from 'react'
import { Col, Row } from 'reactstrap';
import { t } from '../services/HelperService';

export class RTLReadOnlyBar extends React.Component {

    constructor(props) {
        super(props);

        
    }


    render() {

        if (!this.props.readOnly) return null;

        const style = {
            backgroundColor: "orangered",
            color: "white",
            fontWeight: "bolder",
            textAlign: "center",
            ...(this.props.compact ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1
            } : null)
        };

        return <Row>
            <Col style={style} md={12}>
                {t(this.props.msg)}
            </Col>
        </Row>;
    }

}